export default {
    'orderId': '15e020f2-8b34-4e7e-a820-91954b4c17c0',
    'orderNumber': '92fc4932723e4811a7d4a0a3e26e92b4',
    'paymentStatus': 'authorizedidpaypending',
    'idPayLink': 'https://meucheckoutsandbox.braspag.com.br/backoffice?l=cielo',
    'merchantName': 'Loja Testes Cielo',
    'shippingZipCode': '25260107',
    'shippingState': 'RJ',
    'shippingCity': 'Duque de Caxias',
    'shippingDistrict': 'Vila Santa Cruz',
    'shippingNumber': '581',
    'shippingStreet': 'Rua São Félix',
    'shippingComplement': 'loja',
    'shippingType': 'Free',
    'shippingMethod': 'Frete grátis',
    'shippingPrice': 0,
    'totalAmount': 100,
    'paymentType': 1,
    'cardBrand': 'Visa',
    'installmentsNumber': 1,
    'installmentPrice': 100,
    'cardLastFour': '1091',
    'isRecurringPayment': false,
    'customerName': 'william frazao',
    'customerPhone': '21983671150',
    'customerIdentity': '134********',
    'discountAmount': 0,
    'createdDate': '2024-06-19T17:48:37.363',
    'shortUrl': 'https://cielolink.com.br/3xrFeTM',
    'items': [
        {
            'unitPrice': 100,
            'quantity': 1,
            'name': 'camisa do descendents',
            'description': 'camisa da banda punk descendents'
        }
    ]
};
